import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Chip, Stack, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { Development } from '~/api/types';
import { colors } from '~/theme';

const ButtonSx: SxProps = {
  'my': 1,
  'py': 2,
  'px': 3,
  'mx': 'auto',
  'backgroundColor': colors.lightGray,
  'display': 'flex',
  'justifyContent': 'space-between',
  'alignItems': 'center',
  'cursor': 'pointer',
  '&:hover': {
    backgroundColor: colors.gray,
  },
  'maxWidth': '100%',
};

const LabelSx: SxProps = {
  textAlign: 'left',
  display: 'block',
  maxWidth: 'calc(100% - 50px)',
};

const ChipSx: SxProps = {
  'background': colors.lightPurple,
  'color': colors.white,
  'fontFamily': 'Inter',
  'fontSize': 12,
  'textTransform': 'uppercase',
  'fontWeight': '700',
  'lineHeight': '150%',
  'height': '18px',
  '& .MuiChip-label': { px: '6.5px' },
};

const TitleSx: SxProps = {
  fontWeight: 'bold',
  fontSize: { xs: 14, md: 16 },
  wordWrap: 'break-word',
};

const CompanySx: SxProps = {
  color: colors.darkGray,
  fontSize: { xs: 12, md: 14 },
  wordWrap: 'break-word',
};

export const DevelopmentSelectionButton: FC<DevelopmentSelectionButtonProps> = ({
  development,
  onClickWhenUrlIsNull,
}) => {
  const { companyName, name, logo, customerPortalUrl, isPayfac } = development;

  const onClick = () => {
    if (customerPortalUrl === null) {
      onClickWhenUrlIsNull();
    } else {
      window.open(customerPortalUrl, '_blank')?.focus();
    }
  };

  return (
    <Stack direction={'row'} sx={ButtonSx} onClick={onClick} gap={2}>
      <img src={logo} alt="Building Icon" style={{ width: 48, height: 48 }} />
      <Stack sx={LabelSx} flex={1}>
        <Typography sx={CompanySx}>{companyName}</Typography>
        <Typography sx={TitleSx}>{name}</Typography>
      </Stack>
      {isPayfac && <Chip label="Imobiliária" sx={ChipSx} />}
      <ChevronRightIcon sx={{ color: colors.darkGray2 }} />
    </Stack>
  );
};

export interface DevelopmentSelectionButtonProps {
  development: Development;
  onClickWhenUrlIsNull: () => void;
}
